/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-08-17 14:45:03
 * @Description: 
 */
/**
 * 提现 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const applylog = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list (params) {
        return axios.get(api + 'applylog/list', { params: params })
    },
    detail (params) {
        return axios.get(api + 'applylog/detail', { params: params })
    },
    // 审核
    review (params) {
        return axios.post(api + 'applylog/review', qs.stringify(params))
    },
    //提现详情
    moneydetail (params) {
        return axios.get(api + 'applylog/moneydetail', { params: params })
    },
    edittype (params) {
        return axios.post(api + 'applylog/type', qs.stringify(params))
    },
    admintx (params) {
        return axios.post(api + 'applylog/admintx', qs.stringify(params))
    }
}

// 导出接口
export default applylog
